import { registerPreview, unregisterPreview } from './bridge';
import createEmbedPreviewSync from './embed-preview-sync';

export default createEmbedPreviewSync;
export { registerPreview, unregisterPreview };
export * from './meta';
export * from './types';
